<template>
  <div>
    <md-tabs class="md-accent" md-alignment="centered">
      <md-tab id="tab-home" md-label="홈"></md-tab>
      <md-tab id="tab-pages" md-label="스토어"></md-tab>
      <md-tab id="tab-posts" md-label="매거진"></md-tab>
    </md-tabs>
  </div>
</template>

<script>
export default {
  name: "tabs",
};
</script>
